import {
  ChannelSettingDropdown,
  type OverrideValue,
} from './ChannelSettingDropdown';

export function ChannelSupportModeSection({
  value,
  onValueChange,
  globalEnabled,
  isReadOnly = false,
}: {
  value: OverrideValue;
  onValueChange: (value: OverrideValue) => void;
  globalEnabled: boolean;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingDropdown
      title="Support Mode"
      description="Override the team-wide support mode setting for this channel"
      value={value}
      onValueChange={onValueChange}
      globalEnabled={globalEnabled}
      isReadOnly={isReadOnly}
    />
  );
}
